var _path, _path2, _circle, _path3, _ellipse, _ellipse2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNoApps = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.467 1.48163V9.11135H40.1413L32.467 1.48163Z",
    fill: "#029DD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9683 10.4052C29.9683 11.0745 30.5037 11.6546 31.2176 11.6546H41.1228V33.1159C41.1228 33.7852 40.5874 34.276 39.9627 34.276H26.7426C28.8645 31.8281 30.1484 28.6341 30.1484 25.1403C30.1484 17.4333 23.9006 11.1855 16.1936 11.1855C15.4144 11.1855 14.6501 11.2493 13.9057 11.3721V1.66007C13.9057 0.9908 14.4411 0.5 15.0658 0.5H29.9683V10.4052Z",
    fill: "#029DD0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0651,
    cy: 25.0708,
    r: 11.5868,
    fill: "#054169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3076 28.7815C11.0887 28.0004 12.355 28.0004 13.136 28.7815L13.7557 29.4011C14.5367 30.1821 14.5367 31.4485 13.7557 32.2295L4.89937 41.0858C4.11832 41.8668 2.85199 41.8668 2.07094 41.0858L1.45132 40.4662C0.670274 39.6851 0.670274 38.4188 1.45132 37.6377L10.3076 28.7815Z",
    fill: "#054169"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.0651,
    cy: 25.0708,
    rx: 7.22689,
    ry: 7.22689,
    fill: "#E5F8FD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.0651,
    cy: 25.0708,
    rx: 7.22689,
    ry: 7.22689,
    fill: "#E5F8FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2016 23.4648C21.0885 23.4648 21.8075 24.1839 21.8075 25.0708C21.8075 28.2423 19.2366 30.8133 16.0651 30.8133C15.1781 30.8133 14.4591 30.0943 14.4591 29.2073C14.4591 28.3607 15.1142 27.667 15.9452 27.6057L16.0651 27.6013C17.4145 27.6013 18.5171 26.5452 18.5916 25.2144L18.5956 25.0708C18.5956 24.1839 19.3146 23.4648 20.2016 23.4648Z",
    fill: "#029DD0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNoApps);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-NoApps.824824bc3d17246353050954d27fedcd.svg";